export default {
  assignBeforePairing:
    "Assign this device to a structure before linking a reader",
  deviceRevoked: "Device revoked",
  deviceReactivated: "Device reactivated",
  deviceShelved: "Device in warehouse",
  deviceUnshelved: "Device back in use",
  credentialsRegenerated: "Credentials regenerated",
  kioskAssigned: "Device assigned successfully",
  readerUpdated: "Reader updated",
  deviceRenamed: "Room updated",
  changeRoomTitle: "Change room",
  addRoomTitle: "Add room",
  changeRoomCurrentLabel: "Current room",
  changeRoomNewLabel: "New room name",
  changeRoomPlaceholder: "e.g. 231H",
  changeRoomNoRoom: "No room",
  changeRoomUnchanged: "Enter a different room name to continue",
  changeRoomConfirm: "Continue",
  changeRoomRemove: "Remove room",
  deviceGoogleAccountUpdated: "Google account updated",
  deviceNotesUpdated: "Notes updated",
  deviceInstalledOnUpdated: "Installation date updated",
  shared: {
    appVersion: "App version",
    brand: "Brand",
  },
  page: {
    kpiTotal: "Active devices",
    kpiTotalHint: "Excluding warehouse stock",
    kpiOnline: "Online",
    kpiOnlineHint: "Full telemetry in the last 3 h",
    kpiIncomplete: "Setup incomplete",
    kpiIncompleteHint: "Missing binding, reader or structure",
    kpiShelved: "In warehouse",
    kpiShelvedHint: "Not in the field",
    title: "Device management",
    subtitle: "Manage devices for structures",
    newDevice: "New device",
    tabDevices: "Devices",
    tabPresets: "Device presets",
    searchPlaceholder: "Search by name, code, structure or other…",
    filterActiveLabel: "Active",
    filterActiveAll: "All",
    filterActiveActive: "Active",
    filterActiveInactive: "Inactive",
    filterSetupLabel: "Setup",
    filterSetupAll: "All",
    filterSetupComplete: "Complete",
    filterSetupIncomplete: "Requires attention",
    filterSetupRevoked: "Revoked",
    filterShelvedLabel: "Warehouse",
    filterShelvedAll: "All",
    filterShelvedInService: "In use",
    filterShelvedOnly: "In warehouse",
    filterTelemetryLabel: "Telemetry status",
    filterTelemetryAll: "All",
    filterTelemetryGray: "Unbound",
    filterTelemetryGreen: "Complete",
    filterTelemetryYellow: "Incomplete",
    filterTelemetryRed: "No report (> 3 h)",
    filterAppVersionAny: "Any",
    filterAppVersionCount: "{{count}} selected",
    filterIncompleteMissingLabel: "Reason",
    filterIncompleteMissingAny: "Any",
    filterIncompleteMissingCount: "{{count}} selected",
    filterAttentionNoTelemetry: "No telemetry",
    filterAttentionOutdatedApp: "Outdated app",
    filterMissingBinding: "Missing software key",
    filterMissingReader: "Missing reader",
    filterMissingStructure: "Missing structure",
    telemetryTooltipGray: "Not logged in or unbound",
    telemetryTooltipGreen: "Complete telemetry",
    telemetryTooltipYellow: "Incomplete telemetry",
    telemetryTooltipRed: "No telemetry (> 3 h)",
    alertLowBattery: "Low battery ({{level}}%)",
    alertWifiWeak: "Weak or no Wi-Fi signal",
    inUseWarningTitle: "Needs attention",
    inUseWarningStaleTelemetry: "No telemetry in the last 24 hours",
    inUseWarningOutdatedAppVersion: "App version older than {{version}}",
    inUseWarningDeviceLowBattery: "Tablet battery is low",
    inUseWarningReaderLowBattery: "Reader battery is low",
    inUseWarningMissingReader: "No reader linked",
    inUseWarningMissingStructure: "No structure assigned",
    inUseWarningMissingRoom: "No room set",
    inUseCheckTelemetry: "Telemetry",
    inUseCheckAppVersion: "App version",
    inUseCheckDeviceBattery: "Batt. tablet",
    inUseCheckReaderBattery: "Batt. reader",
    inUseCheckReader: "Reader",
    inUseCheckStructure: "Structure",
    inUseCheckRoom: "Room",
    inUseCheckOk: "OK",
    inUseCheckUnknown: "Unknown",
    setupBadgeIncomplete: "Incomplete",
    setupBadgeRevoked: "Revoked",
    setupBadgeIncompleteTooltipTitle: "Still required:",
    setupBadgeIncompleteTooltipDesc:
      "This device cannot accept payments until setup is complete.",
    setupBadgeRevokedTooltip: "This device has been revoked",
    setupMissingBinding: "Software key binding",
    setupMissingBindingDesc:
      "The tablet must log in with its software key at least once.",
    setupMissingPairing: "Payment reader link",
    setupMissingPairingDesc:
      "A payment reader must be linked to this tablet to process card payments.",
    setupMissingAssignment: "Structure assignment",
    setupMissingAssignmentDesc:
      "The device must be assigned to a host structure.",
    colDevice: "Room",
    colSerial: "S/N",
    colGoogleAccount: "Google account",
    colFreekioskUnlock: "FK unlock",
    colReader: "Reader",
    colHouse: "Structure",
    colLastTelemetry: "Last telemetry",
    colLastInteraction: "Last interaction",
    colInstalledOn: "Installed on",
    colInUse: "In use",
    colActions: "Actions",
    selectRow: "Select {{name}}",
    selectAllFiltered: "Select all {{count}} filtered",
    exportCsv: "Export CSV",
    emptySearch: "No devices found matching your search.",
    emptyDefault: "No devices found. Create your first device to get started.",
    readerPair: "Link",
    readerOpenTitle: "Go to reader",
    readerUnpairTitle: "Unlink reader",
    readerUnpairConfirm:
      "Unlink this reader from the tablet? Pairing with SumUp is kept; payments stay disabled until you link again.",
    readerUnpaired: "Reader unlinked",
    houseOpenTitle: "Go to structure",
    houseRemoveTitle: "Remove structure from device",
    houseRemoveConfirm:
      'Remove "{{name}}" from this device? It will become unassigned.',
    houseRemoved: "Structure removed",
    structureLeaveIntro:
      'Leaving "{{name}}" will clear live occupancy on this tablet.',
    structureLeaveCurrentHeading: "Current guests (stay ends, kept in history)",
    structureLeaveFutureHeading: "Upcoming guests (deleted completely)",
    structureLeaveCurrentNote:
      "Current stays are ended now and remain in this structure’s history.",
    structureLeaveFutureNote: "Upcoming stays are removed and cannot be restored.",
    structureLeaveEmpty: "No current or upcoming guests on this tablet.",
    structureLeaveLoading: "Checking guests…",
    assignLeaveIntro:
      'This tablet is leaving "{{name}}". Live occupancy will be cleared before assigning the new structure.',
    roomChangeTitle: "Change room?",
    roomChangeIntro:
      "This tablet has current or upcoming guests. Choose what happens to them.",
    roomChangeNewLabel: "New room:",
    roomChangeCurrentHeading: "Current guests",
    roomChangeFutureHeading: "Upcoming guests",
    roomChangeTransferHelp:
      "Transfer: keep guests on this tablet under the new room name.",
    roomChangeDiscardHelp:
      "Discard: end current guests (history kept) and delete upcoming stays.",
    roomChangeTransfer: "Transfer guests",
    roomChangeDiscard: "Discard occupancy",
    assign: "Assign",
    moreActionsTitle: "More actions",
    regenerateConfirm:
      'Regenerate password for "{{name}}"? Existing tablet sessions will be invalidated and the current password will stop working.',
    revokeConfirm:
      "Revoke the credentials of “{{name}}”? The tablet will be signed out and cannot log in again until you reactivate it.",
    credentialModalTitle: "Credentials regenerated",
    credentialModalDesc:
      "The password has been regenerated. Save these credentials now: the password is shown only once.",
    statusPartial: "Partially configured",
    assignModalTitle: "Assign device",
    assignModalIntro: "Assign {{name}} to a host and structure.",
    selectHostStep: "1) Select host",
    selectHouseStep: "2) Select structure",
    searchHostsPlaceholder: "Search hosts…",
    searchHousesPlaceholder: "Search structures…",
    searchHousesDisabledPlaceholder: "Select a host first…",
    noHostsFound: "No hosts found.",
    pickHostForHouses: "Pick a host to see its structures.",
    noHousesFound: "No structures found.",
    noAddressSet: "No address set",
    assignedDevicesLabel: "Assigned devices:",
    assignSubmit: "Assign",
    otherInfoTitle: "Other device info",
    fieldRoomName: "Room",
    fieldKioskCode: "Device code",
    fieldSerialNumber: "Serial number",
    fieldSoftwareId: "Software ID",
    fieldGoogleAccount: "Google account",
    fieldReaderId: "Reader ID",
    fieldDisplayInches: "Display inches",
    fieldResolution: "Resolution",
    fieldAndroidVersion: "Android version",
    valueAppVersionUnknown: "Unknown",
    valueAppVersionLegacy: "<=0.4.0",
    valueFreekioskUnlockUnavailable: "—",
    editNotesTitle: "Notes",
    editInstalledOnTitle: "Installation date",
    insertInstalledOn: "Insert date",
    notesPlaceholder: "Add a note…",
    fieldLastTelemetryReport: "Last telemetry received",
    sectionTelemetryData: "Telemetry data",
    sectionTelemetryDeviceStatus: "Device status (FreeKiosk)",
    sectionTelemetryGpsLocation: "Location (device GPS)",
    valueTelemetryNever: "Never",
    valueTelemetryEmpty: "No data yet",
    fieldHouse: "Structure",
    valueUnbound: "Unbound",
    valueNotPaired: "Not linked",
    valueUnassigned: "Unassigned",
    menuRegenerateCredentials: "Regenerate credentials",
    menuRevokeDevice: "Revoke credentials",
    menuReactivateDevice: "Reactivate credentials",
    menuNotes: "Notes",
    menuManagePresences: "Manage guests",
    menuOtherInfo: "Other info",
    changeRoomTitle: "Change room",
    renameDeviceTitle: "Change room",
    roomNamePlaceholder: "Room name",
    roomNameEmpty: "Room name cannot be empty",
    editGoogleAccountTitle: "Edit Google account",
    telemetryBattery: "Battery",
    telemetryWifi: "WiFi signal",
    telemetryAudio: "Audio volume",
    telemetryStorage: "Storage used",
    telemetryMemory: "RAM used",
    telemetryUnavailable: "-",
    telemetryDataAge: "Data from {{age}}",
  },
  createModal: {
    titleCreate: "Create New Device",
    titleCreated: "Device Created!",
    hardwareIdLabel: "Serial number",
    hardwareIdPlaceholder: "e.g., R52N80ABCDE",
    hardwareIdRequired: "Please enter the tablet serial number",
    googleAccountLabel: "Google account",
    googleAccountPlaceholder: "e.g., tablet@company.com",
    googleAccountRequired: "Please enter the Google account email",
    roomNameLabel: "Room (optional)",
    roomNamePlaceholder: "e.g., 231H",
    presetSelectorTitle: "Choose a device preset",
    presetsEmpty:
      "No presets found. You can create one from the Device presets page or use manual mode below.",
    presetCardSpecs: 'Android {{version}} • {{resolution}} • {{inches}}"',
    presetRequired: "Please select a device preset or switch to manual mode",
    manualToggle: "Enter hardware details manually",
    brandPlaceholder: "e.g., Samsung",
    androidVersionLabel: "Android Version",
    androidVersionPlaceholder: "e.g., 14",
    resolutionLabel: "Display Resolution",
    resolutionPlaceholder: "e.g., 1920x1200",
    inchesLabel: "Display Inches",
    inchesPlaceholder: "e.g., 10.1",
    inchesInvalid: "Display inches must be a valid number",
    submit: "Create Device",
    successTitle: "Device created successfully!",
    successDescription:
      "Use these credentials to log in from the tablet. They will not be shown again.",
    deviceNameLabel: "Room",
    modelLabel: "Model",
    modelPlaceholder: "e.g., Tab A9",
    kioskCodeLabel: "Device Code",
    passwordLabel: "Password",
    qrHelp:
      "Scan this QR from the tablet login screen to auto-fill credentials.",
    importantLabel: "Important:",
    importantDescription:
      "Save these credentials now. Anyone who scans this QR can log in until you regenerate the password.",
  },
  presets: {
    validationRequired: "All fields are required",
    validationDisplayInches:
      "Display inches must be a valid number greater than zero",
    created: "Preset created",
    updated: "Preset updated",
    deleted: "Preset deleted",
    deleteConfirm: 'Delete preset "{{name}}"?',
    brandPlaceholder: "Brand (e.g. TCL)",
    modelPlaceholder: "Model (e.g. TAB 10L)",
    androidVersionPlaceholder: "Android version (e.g. 15)",
    resolutionPlaceholder: "Resolution (e.g. 800x1280)",
    inchesPlaceholder: "Inches (e.g. 10.1)",
    save: "Save preset",
    add: "Add preset",
    colModel: "Model",
    colAndroid: "Android",
    colResolution: "Resolution",
    colInches: "Inches",
    inchesValue: "{{inches}}″",
    colActions: "Actions",
    empty: "No presets yet.",
    editTitle: "Edit preset",
    deleteTitle: "Delete preset",
  },
} as const;
